module.exports = __webpack_public_path__ + "img/沐浴区.8c712972.webp";